module.exports = __webpack_public_path__ + "img/PXL_20230524_200243499.b7bd16c2.jpg";